<template>
  <div id="AddEPaper2" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回信件列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
          <thead class="ncut-thead-menu">
            <tr>
              <th style="min-width: 6em">申請學年度：</th>
              <th style="min-width: 2em">
                <input
                  type="text"
                  onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                  onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                  onpaste="return false"
                  maxlength="3"
                  v-model="queryInfo.STime"
                  placeholder="如111"
                />
              </th>

              <th style="min-width: 6em">學期：</th>
              <th style="min-width: 2em">
                <input
                  type="text"
                  onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                  onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                  onpaste="return false"
                  maxlength="1"
                  v-model="queryInfo.ETime"
                  placeholder="如1"
                />
              </th>

              <th style="min-width: 30em" colspan="3">
                <b-button variant="success" tabindex="3" @click="query1()"
                  ><b-icon icon="search" />&nbsp;{{
                    $t("message.Query_cmd")
                  }}</b-button
                >&nbsp;
              </th>
            </tr>
          </thead>
          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>收件者:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.recipient"
                  ref="inputData.recipient"
                />
              </div>
            </td>
          </tr>
          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>主旨:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.title"
                  ref="inputData.title"
                  placeholder="請輸入主旨"
                />
              </div>
            </td>
          </tr>
          <tr align="left">
            <td>
              <span class="red_star">＊</span>內容：
              <Ckeditor
                :config="config"
                placeholder="請輸入內容"
                v-model="inputData.content"
                ref="inputData.content"
              ></Ckeditor>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="SendEPaper2()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>
  </div>
</template>


<script>
import * as tools from "../tool";
//import Ckeditor from "vue-ckeditor2";
import CkEditor from "ckeditor4-vue";
import "../../static/config.js"; // 使用相对路径引用 config.js 文件


export default {
  name: "AddEPaper2",
  components: {
    Ckeditor:CkEditor.component,
  },
  data() {
    return {
      mode: true,
      file: [{ name: "", RowId: "" }],
      inputFlag: false,
      linkText: null,
      total: 0,
      isIE: false,
      getTeacherData: null,
      inputData: {
        title: null,
        content: null,
        showAttached: false,
        UpdateUser:null,
        Info: [],
        recipient: null,
      },
      docRecordList: null,
      queryInfo: {
        STime: null,
        ETime: null,
      },
      currentPage: 1,
      cid: "",
      pageSize: 10,

      config: {
        toolbar: [
          ["Source", "-", "Preview", "-", "Templates"],
          [
            "Cut",
            "Copy",
            "Paste",
            "PasteText",
            "PasteFromWord",
            "-",
            "Undo",
            "Redo",
          ],
          ["Find", "Replace", "-", "SelectAll", "-", ""],
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "-",
            "CopyFormatting",
            "RemoveFormat",
          ],
          [
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Blockquote",
            "CreateDiv",
            "-",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "BidiLtr",
            "BidiRtl",
            "Language",
          ],
          ["Link", "Unlink", "Anchor"],
          [
            "Image",
            "Table",
            "HorizontalRule",
            "Smiley",
            "SpecialChar",
            "PageBreak",
            "Iframe",
          ],
          ["Styles", "Format", "Font", "FontSize"],
          ["TextColor", "BGColor"],
          ["Maximize", "ShowBlocks"],
          ["About"],
        ],
        font_names: '標楷體/標楷體, Microsoft JhengHei, DFKai-SB, sans-serif;'+
        'Arial/Arial, Helvetica, sans-serif;' +
        'Comic Sans MS/Comic Sans MS, cursive;' +
        'Courier New/Courier New, Courier, monospace;' +
        'Georgia/Georgia, serif;' +
        'Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;' +
        'Tahoma/Tahoma, Geneva, sans-serif;' +
        'Times New Roman/Times New Roman, Times, serif;' +
        'Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;' +
        'Verdana/Verdana, Geneva, sans-serif;'

       },
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    SendEPaper2(){
      this.checkInput();
      this.inputData.UpdateUser = this.user.id;

      let vm = this;

      this.$http
        .put("./WebApi/EconomicDisadvantage/SendEPaper2/", vm.inputData)
        .then((response) => {
          if (!tools.isNull(response)) {
           // vm.inputData = response.data;

           tools.showAlert(vm, "success", "發送成功" );
           this.close();
          }
          else
          {

            tools.showAlert(vm, "danger", "發送失敗" );
           this.close();

          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });


    },
    checkSaveData() {
      let msg = "";
      if (this.isEmpty(this.queryInfo.STime)) msg = "請輸入申請學年度";
      else if (this.isEmpty(this.queryInfo.ETime)) msg = "請輸入學期";

      return msg;
    },
    isEmpty(data) {
      return data != "" && data != null && data != undefined && data.length > 0
        ? false
        : true;
    },
    ArrayToString(arr) {
      var recipientString = "";
      for (var i = 0; i < arr.length; i++) {
        recipientString += arr[i].eMail.trim() + ";";
      }
      // 移除最后一个分号
       recipientString = recipientString.slice(0, -1);
       this.inputData.recipient = recipientString;
    },

    query1() {
      var msg = this.checkSaveData();
      if (0 == msg.length) {
        let vm = this;
        vm.docRecordList = null;
        vm.total = 0;

        this.$http
          .put("./WebApi/EconomicDisadvantage/GetMailList", vm.queryInfo)
          .then((response) => {
            if (response.data != null) {
              vm.docRecordList = response.data;
              vm.total = vm.docRecordList.length;
              vm.ArrayToString(vm.docRecordList);
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      } else {
        tools.showAlert(this, "danger", "對不起,請輸入" + msg);
      }
    },
    empty(str) {
      if (
        typeof str == "undefined" ||
        !str ||
        str.length === 0 ||
        str === "" ||
        !/[^\s]/.test(str) ||
        /^\s*$/.test(str)
      ) {
        return true;
      } else {
        return false;
      }
    },

    checkInput() {
      this.inputFlag = false;
      if (this.empty(this.inputData.recipient)) {
        alert("請輸入收件者");
        this.$refs["inputData.recipient"].focus();
        this.inputFlag = true;
        return;
      }
      if (this.empty(this.inputData.title)) {
        alert("請輸入主旨");
        this.$refs["inputData.title"].focus();
        this.inputFlag = true;
        return;
      }

      if (this.empty(this.inputData.content)) {
        alert("請輸入內容");
        this.$refs["inputData.content"].focus();
        this.inputFlag = true;
        return;
      }
    },
    AddEPaper2() {
      this.checkInput();
      this.inputData.UpdateUser = this.user.id;
      this.inputData.showAttached = 0;
      let vm = this;
      if (vm.inputFlag != true) {
        this.$http
          .put("./WebApi/EconomicDisadvantage/AddEPaper2/", this.inputData)
          .then((response) => {
            if (0 < response.data) {
              tools.showAlert(vm, "success", "增加信件成功");
              this.close();
            } else {
              tools.showAlert(vm, "danger", "對不起,增加信件失敗");
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      }
    },

    close() {
      this.$emit("hideModal");
    },
  },
  created() {
    console.log("======created AddEPaper2View =====");

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
